import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { parseString } from 'xml2js';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  private rssFeedUrl = 'https://www.aci.it/index.php?type=100'; 

  constructor(private http: HttpClient) {}

  getLatestNews(): Observable<any> {
    return this.http.get(this.rssFeedUrl, { responseType: 'text' }).pipe(
      map((xmlData: string) => {
        let newsItems;
        parseString(xmlData, { explicitArray: false }, (error, result) => {
          newsItems = result.rss.channel.item;
        });
        return newsItems;
      })
    );
  }
}
